/**
 * Mock implementation types
 *
 * This file only exports mock class implementations.
 * For base types, see src/types directory.
 */

// Data mocks
export {MockData} from './data/data';

// Media mocks
export {MockImage} from './media/image';

// Service mocks
export {MockNotification} from './services/notification';

// System mocks
export {MockArgs} from './system/args';
export {MockConfig} from './system/config';
export {MockDevice} from './system/device';
export {MockFileManager} from './system/filemanager';
export {MockLocation} from './system/location';

// UI mocks
export {MockAlert} from './ui/alert';
export {MockColor} from './ui/color';
export {MockFont} from './ui/font';
export {MockLinearGradient} from './ui/gradient';
export {MockSize} from './ui/size';
export {
  MockWidget,
  MockWidgetDate,
  MockWidgetImage,
  MockWidgetSpacer,
  MockWidgetStack,
  MockWidgetText,
} from './ui/widgets';
